var map = {
	"./al-midrar": 25080,
	"./al-midrar.js": 25080,
	"./anees_hussain": 59040,
	"./anees_hussain.js": 59040,
	"./astc": 26068,
	"./astc.js": 26068,
	"./default": 55024,
	"./default.js": 55024,
	"./edcentra": 20130,
	"./edcentra.js": 20130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35102;